
import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { useConsultorioStore } from '../../store/consultorioStore';
import { consultorioService } from '../../services/ConsultorioService';
import { DateTime } from "luxon";
import { Reporte } from "@/addons/Reporte";
import HeadReport from "@/components/HeadReport.vue";

@Component({
	name: "ReporteConvenio",
	components: {HeadReport}
})
export default class ReporteConvenio extends Vue {

	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();
	public convenio_id:number|null = null;
	public fechaInicial = DateTime.now().minus({days: 30}).toFormat("yyyy-MM-dd");
	public fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");
	swTipo = 'pacientes';
	mounted() {
		this.consultorioService.getConvenios();
	}
	getReporteConvenios(tipo:string) {
		this.swTipo = tipo;
		let data = {
			convenio_id: this.convenio_id,
			tipo: this.swTipo,
			fecha_inicial: this.fechaInicial,
			fecha_final: this.fechaFinal
		}
		this.consultorioService.getReporteConvenio(data)
	}

	get ingresos(): any {
		return this.consultorioStore.pagos;
	}
	get loading(): boolean {
		return this.consultorioStore.loading;
	}
	get convenios(): any {
		// const conveniosAll = [{id: null, nombre: 'Sin Seguro'}, ...this.consultorioStore.convenios];
		return this.consultorioStore.convenios;
	}
	get dataReporte(): any {
		return this.consultorioStore.dataReporte;
	}

	imprimir() {
    const css = ".print table {border-collapse: collapse} .print td {padding:0.5 !important; font-size: xx-small !important;}"
    const p = new Reporte('area_impresion');
    p.orientacion ='vertical';
    p.otroCss = css;
    p.imprimir();
  }
}
